import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { Sidebar } from './components/layout/Sidebar';
import { Header } from './components/layout/Header';
import { Dashboard } from './pages/Dashboard';
import { Projects } from './pages/Projects';
import { ProjectDetail } from './pages/ProjectDetail';
import { ProjectCalendar } from './pages/ProjectCalendar';
import { Procurement } from './pages/Procurement';
import { ComplianceDeadlines } from './pages/ComplianceDeadlines';
import { OMAMandate } from './pages/OMAMandate';
import { CabinetDecisions } from './pages/CabinetDecisions';
import { CabinetDecisionDetail } from './pages/CabinetDecisionDetail';
import { Alerts } from './pages/Alerts';
import { NDP6Progress } from './pages/NDP6Progress';
import { Reports } from './pages/Reports';
import { MinistryCompliance } from './pages/MinistryCompliance';
import { SystemImportance } from './pages/SystemImportance';
import { SystemArchitecture } from './pages/SystemArchitecture';
import { MonthlyPerformance } from './pages/MonthlyPerformance';
import GlassButtonDemo from './pages/GlassButtonDemo';

// Layout Wrapper
const Layout = ({ children }) => (
  <div className="flex min-h-screen bg-slate-50">
    <Sidebar />
    <div className="flex-1 ml-64">
      <Header />
      <main className="pt-20 px-6 pb-12">
        {children}
      </main>
    </div>
  </div>
);

// Placeholder Pages
const Placeholder = ({ title }) => (
  <div className="flex flex-col items-center justify-center h-[60vh] text-slate-400 text-center px-6">
    <div className="h-16 w-16 bg-slate-100 rounded-full flex items-center justify-center mb-4">
      <span className="text-2xl">🏗️</span>
    </div>
    <h2 className="text-2xl font-bold mb-2 text-slate-600">{title}</h2>
    <p className="max-w-md">This module is currently being finalized for the Release 1 deployment of GovTrack Namibia.</p>
  </div>
);

function App() {
  return (
    <AppProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/system-importance" element={<SystemImportance />} />
            <Route path="/system-architecture" element={<SystemArchitecture />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/project-calendar" element={<ProjectCalendar />} />
            <Route path="/procurement" element={<Procurement />} />
            <Route path="/compliance" element={<ComplianceDeadlines />} />
            <Route path="/oma-mandate" element={<OMAMandate />} />
            <Route path="/cabinet-decisions" element={<CabinetDecisions />} />
            <Route path="/cabinet-decisions/:id" element={<CabinetDecisionDetail />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/ndp6" element={<NDP6Progress />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/ministry-compliance" element={<MinistryCompliance />} />
            <Route path="/monthly-performance" element={<MonthlyPerformance />} />
            <Route path="/users" element={<Placeholder title="User Management" />} />
            <Route path="/settings" element={<Placeholder title="System Settings" />} />
            <Route path="/glass-demo" element={<GlassButtonDemo />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </Router>
    </AppProvider>
  );
}

export default App;